import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const Contact: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section
      id="contact"
      className={`contact-section fade-in ${isVisible ? 'visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <h2 className="section-title">{t.contact.title}</h2>
        <p className="contact-text">
          {t.contact.description}{' '}
          <strong>
            <a href={`mailto:${t.contact.email}`}>{t.contact.email}</a>
          </strong>{' '}
          {t.contact.suffix}
        </p>
        <div className="contact-form-embed">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSeX3cfLnxph7xr8SlrERnyWcJgHQKijIN2YtmFg7BoZBpJ6KQ/viewform?embedded=true"
            title="Sparkr Contact Form"
            loading="lazy"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;

